<template>
  <div class="animated fadeIn">
    <b-card no-body>
      <div class="card-smallHeader ">
        <i class="fa fa-list mr-2"></i>
        <strong>Fiches Niveau 2 en cours</strong>
      </div>
      <b-card-body class="small-padding">
        <v-server-table id="fiche_en_cours_table" ref="ficheTable" :columns="columns" :url="url" :options="options" style="overflow: hidden;">
          <div slot="afterLimit">
              <b-button v-if="canCreateFiche()" type="button" @click.prevent="addFiche()" size="md" variant="success" class="pull-right ml-3">
                <i class="fa fa-plus"></i> Nouvelle fiche
              </b-button>
          </div>
          <div v-if="props.row.annee || props.row.date_appel" slot="numero_fiche" slot-scope="props" class="slot-date">
            <router-link  :to="getSrc(props.row.id)">
              <span class="badge badge-warning p-2 mb-1 clickable" @click.prevent="showFiche(props.row)">FC{{ props.row.annee }}-{{ props.row.numero_annee.toString().padStart(5,'0') }}</span>
            </router-link>
            <br>
            <span class="badge badge-success p-2">{{ formatDateHeure(props.row.date_appel) }}</span>
          </div>
          <div v-if="props.row.beneficiaire_nom || props.row.beneficiaire_prenom" slot="nom_contact" slot-scope="props">
            <span style="color:#C72C48;">{{ getBeneficiaireNom(props.row) }}</span><br>
            <span>{{ props.row.structure_nom }} ({{ props.row.structure_siren }} - {{ props.row.segment }})</span><br>
            <span style="color:#225CB5;"><i class="fa fa-folder-open"></i><i> {{ getBeneficiaireNom(props.row) }}</i></span><br>
            <span>{{ props.row.demande_objet }}</span>
          </div>
          <div v-if="props.row.contact_tel" slot="tel_contact" slot-scope="props">
            <span><strong>{{ props.row.contact_tel.replace(/(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})/, '$1 $2 $3 $4 $5') }}</strong></span><br>
            <span v-html="props.row.dernier_suivi"></span>
          </div>
          <div v-if="props.row.type" slot="criticite" slot-scope="props" class="text-center">
            <span :class="props.row.type == 'U' ? 'badge badge-danger p-2' : 'badge badge-warning p-2'">{{ props.row.type }}</span>
          </div>
          <div v-if="props.row.domaine_libelle" slot="bo_dest" slot-scope="props" class="text-center">
            <span>{{ props.row.domaine_libelle }}</span><br>
            <span>{{ props.row.garantie }}</span>
          </div>
          <div v-if="props.row.gestionnaire" slot="gestionnaire" slot-scope="props">
            <span style="color:#008000;">{{ props.row.gestionnaire ? props.row.gestionnaire.prenom + ' ' + props.row.gestionnaire.nom : '' }}</span>
          </div>
          <div v-if="props.row.status" slot="statut" slot-scope="props" @click.prevent="showFiche(props.row)" class="clickable text-center">
            <span :class="getClassStatus(props.row)">{{ props.row.status ? props.row.status.libelle_bo : '' }}</span>
          </div>
        </v-server-table>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
  import { formatDate } from "@/utils/communHelper"
  import { downloadFile, isEmpty } from "@/utils/fileHelper"
  import { espaceRCRules as rules, hasRule } from '@/utils/rulesHelper'

  export default {
    name: "fiches_en_cours",
    data() {
      let self = this;
      return {
        url: 'espaceRelationClient/fiche-niv2/list',
        formatDate,
        filter: '',
        isEmpty,
        dataIsReady: true,
        columns: ['numero_fiche', 'nom_contact', 'tel_contact', 'criticite', 'bo_dest', 'gestionnaire', 'statut'],
        items: [],
        options: {
          headings: {
            numero_fiche: 'N° Fiche\nDate/Heure',
            nom_contact: 'Nom Contact\nRéf. Dossier/Demande client',
            tel_contact: 'N° de Tel\nDernière mise à jour',
            criticite: 'Criticité',
            bo_dest: 'BO Dest.\nGarantie',
            gestionnaire: 'Prise en Charge',
            statut: 'Statut'
          },
          columnsClasses: {
            numero_fiche: 'col-xs',
            nom_contact: 'pre-formatted sort-top tooltip-cell position-r',
            tel_contact: 'pre-formatted tooltip-cell position-r'
          },
          resizableColumns: true,
          perPage: 10,
          filterable: ["criticite", "statut"],
          // filterAlgorithm: {
          //   criticite(row, query) {
          //     return (row.type.toLowerCase()).includes(query.toLowerCase());
          //   },
          //   statut(row, query) {
          //     return (row.status.libelle_bo.toLowerCase()).includes(query.toLowerCase());
          //   }
          // },
          texts:{
            filterPlaceholder:"Criticité ou Statut"
          },
          // sortable: ['numero_fiche', 'nom_contact', 'criticite', 'statut'],
          perPageValues: [10, 25, 50],
          sendInitialReqest: false,
          requestFunction: function (data) {
            self.url = '/espaceRelationClient/fiche-niv2/list'

            self.$store.commit('IS_LOADING', true);
            if (!isEmpty(self.filter)) {
              data.query = self.filter
            }
            
            return axios.get(self.url, {
              params: data
            })
              .then(function (response) {
                self.$store.commit('IS_LOADING', false);
                // console.log('data',data)
                
                return response;
              })
              .catch(function (e) {
                console.log(e)
                self.$store.commit('IS_LOADING', false)
                self.$swal({
                  position: 'top',
                  type: 'error',
                  title: 'Attention !!',
                  text: 'Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI',
                  showConfirmButton: false,
                  timer: 5000
                });
              }.bind(this));
          },
        },
      }
    },
    watch: {
      // filter() {
      //   console.log(this.filter)
      // }
    },
    created() {
      // this.listFiches()
    },
    mounted() {

      if (this.$route.query.filter) {
        this.filter = this.$route.query.filter
        this.$refs['ficheTable'].setFilter(this.$route.query.filter);
      }
      this.$refs['ficheTable'].refresh()
    },
    methods: {
      formatDateHeure(textDate) {
        let date = textDate !== null ? new Date(textDate).toLocaleString("fr-FR") : "-";
        return date;
      },
      getClassStatus(fiche) {
        // console.log(fiche)
        let cssClass = '';
        if (!isEmpty(fiche.status)) {
          switch (fiche.status.libelle_bo) {
            case 'AV':
              cssClass = 'badge badge-danger p-2';
              break;
            case 'AT':
              cssClass = 'badge badge-warning p-2';
              break;
            case 'EC':
              cssClass = 'badge badge-primary p-2';
              break;
            case 'CL':
              cssClass = 'badge badge-success p-2';
              break;
            default:
              cssClass = 'badge badge-secondary p-2';
          }
        }
        
        return cssClass;
      },
      canCreateFiche() {
        return hasRule(rules.CAN_MANAGE_FICHES_NIV2);
      },
      addFiche() {
        this.$router.push({ path: "/espace-rc/fiche/add", query: {filter: this.$refs['ficheTable'].query} })
        // window.open('/espace-rc/fiche/add', '_blank')
      },
      showFiche(fiche) {
        // console.log(this.$refs['ficheTable'])
        this.$router.push({ path: "/espace-rc/fiche/show/" + fiche.id, query: {filter: this.$refs['ficheTable'].query} })
        // window.open('/espace-rc/fiche/show/' + fiche.id, '_blank')
      },
      getBeneficiaireNom(fiche) {
        let formatedName = ''
        if (!isEmpty(fiche.beneficiaire_prenom)) {
          formatedName += fiche.beneficiaire_prenom[0].toUpperCase() + fiche.beneficiaire_prenom.slice(1).toLowerCase()
        }
        if (!isEmpty(fiche.beneficiaire_nom)) {
          formatedName += ' ' + fiche.beneficiaire_nom
        }
        return formatedName
      },
      getSrc(id) {
        if (!isEmpty(id)) {
              return {
                path: '/espace-rc/fiche/show/' + id
              }
        } else {
              return null;
        }
      },
    }
  }
</script>

<style>
  span.rouge {
    color:#C72C48;
    font-weight: bold;
  }
  span.suivi_italic {
    color: #000;
    font-weight: normal;
    font-style: italic;
  }
  span.noir {
    color: #000;
    font-weight: bold;
    font-style: italic;
  }
  #fiche_en_cours_table th, #fiche_en_cours_table td {
    padding: 0.5rem;
  }
  #fiche_en_cours_table th {
    padding-top: 5px;
    padding-bottom: 5px;
  }
</style>
